export default function () {
  controller('popup', self => {
    const close = $('.js-popup-close');
    const showQuestion = $('.popup-form__question-trigger');


    $('[data-fancybox]').fancybox({
      buttons: false,
      smallBtn: false,
      touch: false,
      beforeClose: function () {
        $('.js-datepicker').datepicker('hide');
      },
      afterShow: function(instance) {
        if (instance.$refs.container.find('.js-prod-slider').length) {
          instance.$refs.container.find('.js-prod-slider').slick('setPosition');
        }
      }
    });

    close.on('click', e => {
      e.preventDefault();
      $.fancybox.close();
    });

    showQuestion.on('click', e => {
      e.preventDefault();      
      let self = $(e.currentTarget);
      
      self.toggleClass('active');
      self.closest('.popup-form__question').find('.popup-form__question-drop').slideToggle(200);
    })

  });
}
